"use client";
import {Fragment, useEffect, useState} from "react";
import PageTitle from "@/components/center/PageTitle";
import UserAvatar from "@/components/user-avatar";
import {UserState, useUserStore} from "@/lib/store/user.store";
import {hidePhone} from "@/lib/util/util";
import dayjs from "dayjs";

const info = [
    {
        name: "登录账号",
        key: "nickname"
    }, {
        name: "手机号码",
        key: "mobile"
    }, {
        name: "上次登录",
        key: "last_time"
    }, {
        name: "IP地址",
        key: "last_ip"
    }
];

export default function Info() {
    const {userInfo} = useUserStore();
    const [user, setUser] = useState<UserState["userInfo"]>(userInfo);
    useEffect(() => {
        userInfo && setUser(userInfo);
    }, [userInfo]);
    return <Fragment>
        <PageTitle title={"账户安全"}/>
        <div className="s-flex space-x-4 my-4">
            <UserAvatar size={60}/>
            <div>
                {
                    info.map(item => {
                        return <div key={item.key} className="s-flex gap-x-3 text-[12px] text-black">
                            <span>{item.name}：</span>
                            <span>{item.key === "mobile" ? hidePhone(user?.member[item.key]) : item.key === "last_time" ?
                                user?.member[item.key] && +user?.member[item.key] !== 0 && dayjs(+user?.member[item.key] * 1000).format("YYYY-MM-DD HH:mm") : user?.member[item.key]}</span>
                        </div>;
                    })
                }
            </div>
        </div>
    </Fragment>;
}
